import React from 'react';

export default function Faux() {
  return <div></div>;
}
